/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import * as moment from 'moment';
import 'moment-timezone';

import {LOCALES_FIRST_DAY} from '../common/constants/locales';
import {networkTimeFromPickerDate, pickerDateFromApiInstant, pickerDateFromNetworkTime} from '../common/locale/network-date-picker-utils';

export function afterSaveAfterInitMods(ref: any, adnTimeShifter: any, timeZone: string, scheduleLocale: string): void {
  const workingLocale = ref.locale || scheduleLocale;
  ref.firstDayOfWeek = LOCALES_FIRST_DAY[workingLocale] || (workingLocale.indexOf('_') > -1 ? 'MONDAY' : 'SUNDAY');
  ref.modOptions = 'DEFAULT';
  if (ref.recurrence && ((ref.recurrence === 'DAILY' && ref.periodTime) || (ref.recurrence === 'MONTHLY' && (ref.periodTime || ref.periodDayOfMonth)) || (ref.recurrence === 'WEEKLY' && (ref.periodTime || ref.periodDayOfWeek)))) {
    ref.modOptions = 'CUSTOM';
  }
  ref.modPeriodTime = ref.periodTime ?
    pickerDateFromNetworkTime(ref.periodTime, timeZone) :
    pickerDateFromApiInstant(moment.tz(timeZone).startOf('day').toDate(), adnTimeShifter);

  ref.periodDayOfMonth = ref.periodDayOfMonth || 1;
  ref.periodDayOfWeek = ref.periodDayOfWeek || 'MONDAY';
}

export function beforeSubmitMods(ref: any, timeZone = 'utc'): void {
  if (ref.modOptions === 'CUSTOM') {
    ref.periodTime = _.isDate(ref.modPeriodTime) ? networkTimeFromPickerDate(ref.modPeriodTime, timeZone) : '00:00:00';
    ref.periodDayOfMonth = _.isNumber(ref.periodDayOfMonth) ? ref.periodDayOfMonth : 1;
    ref.periodDayOfWeek = ref.periodDayOfWeek || 'MONDAY';
  } else {
    ref.periodTime = null;
    ref.periodDayOfMonth = null;
    ref.periodDayOfWeek = null;
  }
}

export function filterReportTemplates(
  templates: any[],
  perms: Record<string, boolean>,
  anyPerms: Record<string, boolean>,
  canSeeAdvertiserReports: boolean
): any[] {
  return _.filter(templates, (rt) => {
    if ((rt.reportType === 'LINE_ITEM' || rt.reportType === 'LINE_ITEM_LIST') && (anyPerms.RUN_REPORTS || anyPerms.MANAGE_ADVERTISING)) {
      return true;
    } else if (rt.reportType === 'SALESPERSON' && (anyPerms.RUN_REPORTS || anyPerms.MANAGE_ADVERTISING)) {
      return true;
    } else if (rt.reportType === 'ADVERTISER' && (perms.MANAGE_BUSINESS || (anyPerms.RUN_REPORTS && canSeeAdvertiserReports))) {
      return true;
    } else if (rt.reportType === 'NETWORK' && (perms.MANAGE_SYSTEM)) {
      return true;
    } else if (rt.reportType === 'AD_UNIT' && (anyPerms.RUN_REPORTS || anyPerms.MANAGE_PUBLISHING)) {
      return true;
    } else if (rt.reportType === 'SITE' && (anyPerms.RUN_REPORTS || anyPerms.MANAGE_PUBLISHING)) {
      return true;
    } else if (rt.reportType === 'SITE_GROUP' && (anyPerms.MANAGE_BUSINESS)) {
      return true;
    } else if (rt.reportType === 'EARNINGS_ACCOUNT' && (anyPerms.MANAGE_BUSINESS)) {
      return true;
    } else if (rt.reportType === 'SELF_SERVICE') {
      return true;
    }
    return false;
  });
}
